import { memo } from "react";
import MudrexIcon from "../MudrexIcon/MudrexIcon";

function CheckBox({
  isActive,
  onClick,
}: {
  isActive: boolean | undefined;
  onClick?: () => void;
}) {
  return (
    <div onClick={onClick}>
      <div
        className={`${
          isActive
            ? "bg-iconography-grad-brand-darkest"
            : "border-[#6424C5] border"
        } cursor-pointer w-[18px] h-[18px] rounded-md flex justify-center items-center mt-[2px]`}
      >
        {isActive ? (
          <MudrexIcon icon="Check" size={14} color="#FFFFFF" />
        ) : null}
      </div>
    </div>
  );
}

export default memo(CheckBox);
